import { DynamicStandaloneTextMultiline } from '@/components/TextMultiline';
import { LabradorComponent } from '@/types/component';
import { getLabStylingClasses } from '@/utils/getLabStylingClasses';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTextMultiline: LabradorComponent = ({ type, meta, data }) => {
  const { bodytext, textAlign, backgroundColor } = data;
  const className = getLabStylingClasses({ backgroundColor, textAlign });

  return (
    <DynamicStandaloneTextMultiline markup={bodytext} options={{ className }} {...withDebugMetadata({ type, meta })} />
  );
};

export default LabradorTextMultiline;
